import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

enum APPLIED_JOB_SORT {
  applicationDate = 'applied_date_desc',
  companyName = 'company_name_asc',
  jobTitle = 'job_title_asc',
}

const APPLIED_JOB_SORT_VARIABLES = {
  applied_date_desc: {
    applicationDate: 'DESC',
  },
  company_name_asc: {
    companyName: 'ASC',
  },
  job_title_asc: {
    jobTitle: 'ASC',
  },
};

const useSort = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentSort =
    (searchParams.get('sort') as APPLIED_JOB_SORT) ||
    APPLIED_JOB_SORT.applicationDate;
  const setCurrentSort = (sort?: APPLIED_JOB_SORT) => {
    if (sort) {
      if (searchParams.has('page')) {
        searchParams.delete('page');
      }

      searchParams.set('sort', sort);
      setSearchParams(searchParams);
    } else if (searchParams.has('sort')) {
      searchParams.delete('sort');
      setSearchParams(searchParams);
    }
  };

  useEffect(() => {
    if (
      !Object.values(APPLIED_JOB_SORT).includes(currentSort) ||
      searchParams.get('sort') === APPLIED_JOB_SORT.applicationDate
    ) {
      setCurrentSort();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSort]);

  return {
    currentSort,
    setCurrentSort,
    sortQueryVar: APPLIED_JOB_SORT_VARIABLES[currentSort],
  };
};

export { useSort, APPLIED_JOB_SORT };
